import { LOCALE_COOKIE_NAME } from '@financialharmony/i18n';
import { Sentry } from '@/lib/sentry';

/**
 * The chosen language, cached in this browser so the app opens in it before the profile is read and a
 * signed-out visitor keeps it. Storage can be unavailable (private window, blocked site data): the
 * language then lasts for the session and the failure is reported, never thrown at the user.
 */
const STORAGE_KEY = LOCALE_COOKIE_NAME;

export function readStoredLocale(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
}

export function writeStoredLocale(locale: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch (error) {
    Sentry.captureException(error);
  }
}

/** True for a `storage` event about the language, so a second tab follows a choice made in this one. */
export function isLocaleStorageEvent(event: StorageEvent): boolean {
  return event.key === STORAGE_KEY;
}
